import React from 'react';
import { StyledHeading } from './HighlightTitle.styles';

export type HighlightTitleProps = {
  /** Should the Title be h1 or h2 component, defaults to h1 */
  isH1?: boolean;
  /**
   *  Should there be a forced break before the first highlight, defaults to false
   *  @deprecated
   */
  hasHighlightBreak?: boolean;
  /**
   *  Words in New Spirit font that are emphasized in the title
   * @deprecated
   */
  highlightText?: string;
  /** Secondary words in New Spirit font that are emphasized in the title, after the titleEnd
   * @deprecated
   */
  secondHighlight?: string;
  /** Words in Circular font after the highlighted text
   * @deprecated
   */
  titleEnd?: string;
  /** Words in Circular font before the highlighted text
   * @deprecated
   */
  titleStart?: string;
  /** Add title as a children, wrap highlight text in span or strong. */
  children?: React.ReactNode;
};

const HighlightTitle: React.FC<HighlightTitleProps> = ({
  isH1 = true,
  hasHighlightBreak = false,
  highlightText,
  secondHighlight,
  titleStart,
  titleEnd,
  children,
}): JSX.Element => {
  const component = isH1 ? 'h1' : 'h2';
  const presentation = isH1 ? 'h1' : 'h3';

  return (
    <StyledHeading component={component} presentation={presentation}>
      {titleStart}
      {hasHighlightBreak && <br />} {highlightText && <span>{highlightText}</span>} {titleEnd}{' '}
      {secondHighlight && <span>{secondHighlight}</span>}
      {children}
    </StyledHeading>
  );
};

export default HighlightTitle;
